import React, { useEffect, useState } from "react";
import { Table, Tag, Input, Button, Card, Skeleton } from "antd";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import SideBar from "../component/SideBar";
import { useSettings } from "../context/settingContext";
import axios from "axios";
import { Link } from "react-router-dom";
import { useOrders } from "../context/ordersContext";

const Order = () => {
    const [searchText, setSearchText] = useState("");
    const { user } = useSettings();
    const userId = user?.id;
    const { getOrders, loading, ordersData } = useOrders();

    useEffect(() => {
        if (userId) getOrders();
    }, [userId]);

    const columns = [
        {
            title: "Order ID",
            dataIndex: "orderId",
            key: "orderId",
            render: (text) => <span className="font-medium">{text}</span>,
        },
        {
            title: "Customer",
            dataIndex: "customer",
            key: "customer",
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                let color = status === "Delivered" || status === "confirmed" || status === "created" ? "green" : status === "pending" || status === "Pending" ? "gold" : "red";
                return <Tag color={color}>{status?.toUpperCase()}</Tag>;
            },
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <Link to={`/dashboard/order/${record.key}`}>
                    <Button
                        icon={<EyeOutlined />}
                        type="default"
                        className="!border !border-brandBlue !text-brandBlue font-semibold hover:!bg-brandBlue hover:!text-white transition-all duration-300 !rounded-lg"
                        style={{
                            background: "rgba(0, 119, 255, 0.05)",
                            backdropFilter: "blur(4px)",
                        }}
                    >
                        View
                    </Button>
                </Link>
            ),
        },
    ];

    const renderSkeletonTable = () => (
        <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
                <div
                    key={i}
                    className="grid grid-cols-6 gap-4 items-center bg-white p-3 rounded-lg shadow-sm"
                >
                    <Skeleton.Input active size="small" style={{ width: 100 }} />
                    <Skeleton.Input active size="small" style={{ width: 140 }} />
                    <Skeleton.Input active size="small" style={{ width: 120 }} />
                    <Skeleton.Input active size="small" style={{ width: 90 }} />
                    <Skeleton.Input active size="small" style={{ width: 80 }} />
                    <Skeleton.Button active size="small" style={{ width: 60 }} />
                </div>
            ))}
        </div>
    );

    const filteredOrders = ordersData.filter((item) => {
        const search = searchText.toLowerCase();
        return (
            item.orderId.toLowerCase().includes(search) ||
            item.customer.toLowerCase().includes(search)
        );
    });

    console.log(ordersData)

    return (
        <div className="flex min-h-screen bg-gray-100 pt-[160px] pb-[50px]">
            <div className="w-64 bg-brandBlue shadow-lg py-8 px-4 text-white rounded-tr-[10px] rounded-br-[10px]">
                <h2 className="text-2xl font-bold mb-10">My Account</h2>
                <SideBar />
            </div>
            <div className="flex-1 p-10 pt-0 pb-0">
                <h2 className="text-4xl font-bold mb-7 text-brandBlue">My Orders</h2>
                <Card className="shadow-xl rounded-2xl">
                    <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-3">
                        <h1 className="text-2xl font-bold text-brandBlue">Orders</h1>
                        <Input
                            placeholder="Search by Order ID or Customer..."
                            prefix={<SearchOutlined />}
                            className="w-full md:w-72"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>

                    {loading ? (
                        renderSkeletonTable()
                    ) : (
                        <Table
                            columns={columns}
                            dataSource={filteredOrders}
                            pagination={{ pageSize: 4 }}
                            className="rounded-lg"
                        />
                    )}
                </Card>
            </div>
        </div>
    );
};

export default Order;
